// Currency / price formatting — the single chokepoint for how a course price
// is displayed. Course prices are stored as a plain number and charged in ZAR
// via Paystack, so we render them with the Rand symbol everywhere.
//
// Per-tenant configurable display currency is a planned follow-up; when it
// lands, this is the one function that needs to change.

/** Format a course price for display, e.g. `R150`. Does NOT special-case 0 —
 *  callers that want a "Free" label should branch on `price === 0` themselves. */
export function formatPrice(price: number): string {
  return `R${price}`;
}
